import { ZAttribute } from "src/types/ZAttribute";
import { zUid } from "src/types/zUid";
import { z } from "zod";

export enum ChildEntitiesButton {
  create = "create",
  assign = "assign",
}

export const zChildEntities = z.object({
  editor: z.literal("ChildEntities"),
  attrId: zUid,
  editable: z.boolean().optional(), // LPLM-1505
  summaryAttrs: zUid.array().optional(),
  buttons: z.nativeEnum(ChildEntitiesButton).array().optional(),
});
export type ZChildEntities = z.infer<typeof zChildEntities>;

export const makeChildEntitiesProps = (
  attr: ZAttribute,
  editorInfo: ZChildEntities | undefined,
) => ({
  parentObjId: attr.referenceId,
  childAttributeId: attr.id,
  editorInfo,
  childDictionaryAttributeId: attr.childDictionaryAttributeId,
  childDictionaryValueId: attr.childDictionaryValueId,
});
